import { render, staticRenderFns } from "./ModalConfiguracaoUsuario.vue?vue&type=template&id=726cca56&scoped=true&"
import script from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfiguracaoUsuario.vue?vue&type=style&index=0&id=726cca56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726cca56",
  null
  
)

export default component.exports